// Modules
import React from "react"

// Components
import QuicklinksCard from "./quick-links"

// Data
import { quicklinks } from "../../../data/quicklinks"

// Model: Quick links
function Quicklinks ({quicklink= quicklinks, quickLinksStyle="lg:grid-cols-4 "}) {
	// Render
	return (
		<div>
			<div className="pb-7">
				<h2 className="text-heading_sm font-bold text-brand">
				Quick Links
				</h2>
				{/* <p className="text-body_base">We’ve got a wide range of solutions for every individual and business. </p> */}
			</div>
			<div className={`grid grid-cols-2 md:grid-cols-3 ${quickLinksStyle} justify-items-center w-full gap-3 md:gap-5`}>
				{quicklink.map(quicklinks =>
					<QuicklinksCard
						title={quicklinks.title}
						svg={quicklinks.image}
						link={quicklinks.link} />
				)}
			</div>
		</div>
	)
}

// Export
export default Quicklinks
